<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded: (sideBar) || (!sideBar && isMouseHovered)
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
  <!-- {{  sideBar }}
  {{   coll }} -->
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <b-img 
                  :src="skin == 'light'  ? (userData.light_logo 
          ? userData.light_logo 
          : (appLogoLightImage 
              ? appLogoLightImage 
              : userData.dark_logo))
      : (userData.dark_logo 
          ? userData.dark_logo 
          : appLogoDarkImage)"
                  alt="logo"
                />
              </span>
              <b-img 
                style="width: 100%"
                class="brand-text"
                :src="skin == 'light' ? (userData.light_name_logo 
          ? userData.light_name_logo 
          : (appNameLightLogo 
              ? appNameLightLogo 
              : userData.dark_name_logo))
      : (userData.dark_name_logo 
          ? userData.dark_name_logo 
          : appNameDarkLogo)"
                alt="logo"
              />
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                style="margin-top:35px;"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
    <div class="menu-fixed new-release">
      <b-link class="w-100 d-flex align-items-center" to="/release-note">
        <feather-icon icon="ClockIcon" size="18" class="d-block mr-50" stroke="#6E6B7B"/><span class="menu-title text-truncate">New Release</span></b-link>
    </div>
  </div>
</template>

<script>
import navMenuItems from "@/navigation/vertical";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import store from "@/store/app-config/index";
import { bus } from "@/main.js";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      skin: this.$store.getters["appConfig/getSkin"],
      userData: this.$cookies.get('userData'),
      sideBar: false,
      coll : localStorage.getItem('is-collapsed')

    };
  },
  mounted() {
    // Check if there's a saved state in local storage
    const savedState = localStorage.getItem('is-collapsed');
    if (savedState !== null) {
      this.sideBar = JSON.parse(savedState);
    }
  },
  computed: {
    mySkin: function () {
      return this.$store.getters["appConfig/getSkin"];
    },
  },
  watch: {
    mySkin: function (val) {
      this.skin = val
    },
  },
  methods:{
    toggleCollapsed() {
    this.sideBar = !this.sideBar; // Corrected variable name
    bus.$emit('dataEvent', this.sideBar);
    localStorage.setItem('is-collapsed',JSON.stringify(this.sideBar))
  }
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      // toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    var {
      appName,
      appLogoLightImage,
      appLogoDarkImage,
      appNameLightLogo,
      appNameDarkLogo,
    } = $themeConfig.app;
    var host = window.location.host; 
    // if(host == 'cothinkr.zircly.com' || host == 'localhost:8080' ){
    if(host == 'cothinkr.zircly.com'){
      appLogoLightImage = require('@/assets/images/logo/CothinkrJustLogo.svg');
      appLogoDarkImage = require('@/assets/images/logo/CothinkrJustLogo.svg');
      appNameLightLogo = require('@/assets/images/logo/CothinkrJustName.svg');
      appNameDarkLogo = require('@/assets/images/logo/CothinkrJustName.svg');
    }
    if(host == 'klizer.zircly.com'){  
      appLogoDarkImage = require('@/assets/images/logo/Klizer_White_JustLogo.png');
      appLogoLightImage = require('@/assets/images/logo/Klizer_Logo_JustLogo.png');
      appNameDarkLogo = require('@/assets/images/logo/Klizer_White_JustName.png');
      appNameLightLogo = require('@/assets/images/logo/Klizer_Logo_JustName.png');
    }
    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      // toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoLightImage,
      appLogoDarkImage,
      appNameLightLogo,
      appNameDarkLogo,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
